"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var modulePermissions_exports = {};
__export(modulePermissions_exports, {
  getGroupEffectivePermissions: () => getGroupEffectivePermissions,
  getModulePermissionGroupRole: () => getModulePermissionGroupRole,
  getRoleEffectivePermissions: () => getRoleEffectivePermissions,
  isModulePermissionGranted: () => isModulePermissionGranted
});
module.exports = __toCommonJS(modulePermissions_exports);
var import_classes = require("./classes");
function getModulePermissionGroupRole(group) {
  const legacyRoles = group.roles;
  return group.role ?? (Array.isArray(legacyRoles) && legacyRoles.length > 0 ? legacyRoles[0] : import_classes.AccountRole.Guest);
}
__name(getModulePermissionGroupRole, "getModulePermissionGroupRole");
function getGroupEffectivePermissions(group) {
  if (group.enabled === false) return [];
  const disabled = new Set(group.disabledPermissions ?? []);
  return (group.permissions ?? []).filter((permission) => !disabled.has(permission));
}
__name(getGroupEffectivePermissions, "getGroupEffectivePermissions");
function getRoleEffectivePermissions(groups) {
  const result = /* @__PURE__ */ new Map();
  for (const group of groups) {
    if (group.enabled === false) continue;
    const role = getModulePermissionGroupRole(group);
    const current = result.get(role) ?? /* @__PURE__ */ new Set();
    for (const permission of getGroupEffectivePermissions(group)) current.add(permission);
    result.set(role, current);
  }
  return result;
}
__name(getRoleEffectivePermissions, "getRoleEffectivePermissions");
function isModulePermissionGranted(groups, role, permission) {
  return getRoleEffectivePermissions(groups).get(role)?.has(permission) ?? false;
}
__name(isModulePermissionGranted, "isModulePermissionGranted");
//# sourceMappingURL=modulePermissions.js.map
